<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Ketentuan Target Affiliate</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div class="section mt-3 mb-3">
                <div class="section-heading">
                    <h2 class="title">Rewards</h2>
                </div>
                <div class="table-responsive mb-2">
                    <table
                        class="table table-bordered table-sm"
                        style="font-size: 10px"
                    >
                        <tr>
                            <th>Tier Transaksi Downline (Bulan)</th>
                            <th>Bonus Komisi</th>
                        </tr>
                        <tr v-for="item in rewards" :key="item.J_Trx">
                            <td class="text-nowrap">
                                {{ item.target | rupiah }} Transaksi
                            </td>
                            <td class="text-nowrap">
                                Rp {{ item.bonus | rupiah }},-
                            </td>
                        </tr>
                    </table>
                </div>
                <div
                    class="padding"
                    style="
                        line-height: 17px;
                        font-size: 12px;
                        text-align: justify;
                    "
                >
                    <h5>Contoh Pemberian Bonus Komisi berdasarkan Tier</h5>
                    <p>
                        <b>Contoh 1</b><br />Mitra A memiliki downline aktif dan
                        sudah terdaftar menjadi Agen Affiliate Plus, Total
                        Transaksi dari Downline Mitra A pada bulan januari 2025
                        adalah <b>8.125 transaksi</b>, berdasarkan dari table
                        tier bonus komisi, maka Mitra A akan mendapatkan bonus
                        komisi sebesar <b>Rp 125.000</b> pada tanggal 5 februari
                        2025 karena berhasil mencapai tier 5.000 transaksi.
                    </p>
                    <p>
                        <b>Contoh 2</b><br />Mitra B memiliki downline aktif dan
                        sudah terdaftar menjadi Agen Affiliate Plus, Total
                        Transaksi dari Downline Mitra B pada bulan februari 2025
                        adalah <b>63.567 transaksi</b>, berdasarkan dari table
                        tier bonus komisi, maka Mitra B akan mendapatkan bonus
                        komisi sebesar <b>Rp 1.250.000</b> pada tanggal 5 maret
                        2025 karena berhasil mencapai tier 50.000 transaksi.
                    </p>
                </div>
            </div>

            <div class="section mt-3 mb-3">
                <div class="section-heading">
                    <h2 class="title">Ketentuan</h2>
                </div>
                <div
                    class="padding"
                    style="
                        line-height: 17px;
                        font-size: 12px;
                        text-align: justify;
                    "
                >
                    <ol>
                        <li>Program Target Affiliate berlaku setiap bulan.</li>
                        <li>
                            Periode Program dimulai awal bulan s.d akhir bulan
                            di bulan berjalan.
                        </li>
                        <li>
                            Rewards Program dapat berubah-ubah setiap bulannya.
                        </li>
                        <li>
                            Program ini hanya dapat diikuti oleh Mitra yang
                            sudah melakukan upgrade ke Agen Affiliate Plus.
                        </li>
                        <li>
                            Agen Affiliate Plus akan otomatis ikut serta dalam
                            program ini selama memenuhi ketentuan yang berlaku.
                        </li>
                        <li>
                            Program ini tidak berlaku bagi karyawan
                            {{ VUE_ENV.VUE_APP_NAME }}
                            beserta keluarga, pihak agensi dan pihak ketiga
                            lainnya yang ikut membantu program ini.
                        </li>
                        <li>
                            Total Transaksi Downline yang dihitung adalah total
                            transaksi dari downline yang akunnya sudah
                            terverifikasi.
                        </li>
                        <li>
                            Rewards yang diberikan dalam bentuk bonus komisi.
                        </li>
                        <li>
                            Bonus komisi akan diberikan maksimal ditanggal 5
                            bulan berikutnya.
                        </li>
                        <li>
                            Pihak penyelenggara sepenuhnya berhak untuk
                            membatalkan, memperpendek, memperpanjang maupun
                            menunda periode program jika dalam keadaan memaksa
                            (Force Majeure)
                        </li>
                        <li>
                            Keputusan Tim {{ VUE_ENV.VUE_APP_NAME }} ada mutlak
                            dan tidak dapat diganggu gugat.
                        </li>
                    </ol>
                </div>
            </div>
            <div class="section inset mt-2">
                <div class="section-heading">
                    <h2 class="title">FAQ</h2>
                </div>

                <div class="accordion" id="faq">
                    <div class="item" v-for="item in faq" :key="item.posisi">
                        <div class="accordion-header">
                            <button
                                class="btn text-left collapsed"
                                type="button"
                                data-toggle="collapse"
                                :data-target="'#faq_' + item.posisi"
                            >
                                <b>{{ item.question }}</b>
                            </button>
                        </div>
                        <div
                            :id="'faq_' + item.posisi"
                            class="accordion-body collapse"
                            data-parent="#faq"
                        >
                            <div class="accordion-content">
                                {{ item.answer }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $axios from '../../../api.js';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    export default {
        data() {
            return {
                loadingApp: true,
                faq: [
                    {
                        posisi: 1,
                        question: 'Siapa saja yang bisa ikut program ini?',
                        answer: 'Program ini dapat diikuti oleh seluruh mitra yang sudah melakukan upgrade menjadi Agen Affiliate Plus.',
                    },
                    {
                        posisi: 2,
                        question:
                            'Apakah perlu mendaftarkan diri untuk mengikuti program ini?',
                        answer: 'Tidak ada pendaftara untuk mengikuti program ini, cukup dengan upgrade mnejadi Agen Affiliate Plus maka otomatis Mitra otomatis akan ikut serta dalam program ini.',
                    },
                    {
                        posisi: 4,
                        question:
                            'Kenapa ada transaksi downline saya yang tidak terhitung?',
                        answer: 'Transaksi downline yang di hitung dalam program ini adalah transkasi dari downline yang sudah melakukan verifikasi akun.',
                    },
                    {
                        posisi: 5,
                        question:
                            'Kapan bonus komisi baru diberikan jika telah mencapai pada tier tertentu?',
                        answer: 'Bonus Komisi akan diberikan maksimal ditanggal 5 bulan selanjutnya dan akan ditambahkan otomatis kedalam komisi.',
                    },
                    {
                        posisi: 6,
                        question:
                            'Apakah ada masa kadaluarsa downline yang dapat dihitung transkasinya dalam program ini?',
                        answer: 'Tidak, selama downline yang kamu miliki memenuhi kriteria maka transkasi downline akan tetap terhitung.',
                    },
                ],
                rewards: [],
                dataTargetAffiliate: {
                    month_selected: moment().format('MM-YYYY'),
                    transaction_downline: 0,
                    bonus_komisi: 0,
                    tier: [],
                },
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
            getDataTargetAffiliate() {
                this.loadingApp = true;
                $axios
                    .get('/referral/target', {
                        params: this.dataTargetAffiliate,
                    })
                    .then(response => {
                        this.rewards = response.data.data.tier;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingApp = false;
                    });
            },
        },
        mounted() {
            this.getDataTargetAffiliate();
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
